export { default } from "./SponsorPlayerLogo";
